import Box from '@amzn/awsui-components-react/polaris/box';

export const KeyLabel = (props: { label: string, value: string }) => (
  <div>
    <Box variant="awsui-key-label">{props.label}</Box>
    <div>{props.value}</div>
  </div>
);